import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import { GatsbyImage } from "gatsby-plugin-image"
import styled from 'styled-components';
import Layout from "../components/layout"
import Seo from '../components/seo';
import Social from '../components/social';



const AboutWrapper = styled.div`
  position: relative;
  padding: 70px 15px 0;
  @media (max-width: 990px) {
    padding: 70px 15px 30px;
  }
  @media (max-width: 575px) {
    padding: 60px 15px 0;
  }
`;

const AboutPageTitle = styled.div`
  margin-bottom: 45px;
  text-align: center;
  @media (max-width: 767px) {
    margin-bottom: 30px;
  }
  p {
    color: #757575;
  }

  h1{
    font-family: var(--title-font);
    font-size: 58px;
    font-weight: 600;
    letter-spacing: -1.5px;
    line-height: 1.3;
    margin-bottom: 40px;

    @media (max-width: 990px) {
      font-size: 37px;
    }
    @media (max-width: 767px) {
      font-size: 35px;
      margin-bottom: 10px;
    }
  }
`;

const AboutImage = styled.div`
  margin-bottom: 90px;
  @media (max-width: 990px) {
    margin-bottom: 60px;
  }
  @media (max-width: 767px) {
    margin-bottom: 40px;
  }
`;

const AboutDetails = styled.div`
  width: 870px;
  max-width: 100%;
  margin: 0 auto;

  h2 {
    font-size: 21px;
    font-weight: 500;
    color: #292929;
    margin-bottom: 20px;
    margin-top: 30px;

    @media (max-width: 990px) {
      margin-bottom: 30px;
    }
    @media (max-width: 767px) {
      font-size: 18px;
      margin-bottom: 25px;
    }
  }

  p {
    color:#757575;
  }
`;

const StyledSocialLinks = styled.div`
  margin-top: 60px;
  position: relative;
  @media (max-width: 767px) {
    margin-top: 40px;
  }
`;

const AboutPage = ({location}) => {
  const data = useStaticQuery(graphql`
    query {
      avatar: file(absolutePath: { regex: "/about.jpg/" }) {
        childImageSharp {
            gatsbyImageData(layout: CONSTRAINED,width: 1200)
        }
      }
      site {
        siteMetadata {
          social{
            url
            name
          }
        }
      }
    }
  `);

  return (
    <Layout location={location}>
          <>

      <Seo 
         title="About Us"
         description="Asirm is a beautiful Gatsby Portfolio theme designed to showcase your work in style. Perfect for designers, artists, photographers and developers to use for their portfolio website."
          location={location} />

      
      <AboutWrapper>
      <AboutPageTitle>
        <h1>About Asirm</h1>
      </AboutPageTitle>

      <AboutImage>
          <GatsbyImage image={data.avatar.childImageSharp.gatsbyImageData} alt="logo"/>
      </AboutImage>
      

      <AboutDetails>
        <h2>Our Story</h2>
        <p>
          Asirm Team is a creative agency specializing in building scalable,
          high-performance web & mobile application. Our main concern is
          creating more value into the application so that can help our
          customers to grow their business.
        </p>
        <p>
          Asirm Team is a creative agency specializing in building scalable,
          high-performance web & mobile application. Our main concern is
          creating more value into the application so that can help our
          customers to grow their business.
        </p>
        <h2>Top Projects</h2>
        <p>
          Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper 
          suscipit lobortis nisl ut aliquip ex ea commodo consequat. 
          Duis autem vel eum iriure dolor in hendrerit in vulputate velit esse
          molestie consequat, vel illum dolore eu feugiat nulla facilisis at 
          vero eros et accumsan et iusto odio dignissim qui blandit praesent 
          luptatum zzril delenit augue duis dolore te feugait nulla facilisi. 
          Nam liber tempor cum soluta nobis eleifend
        </p>

        <StyledSocialLinks>
          <Social social={data.site.siteMetadata.social}/>
        </StyledSocialLinks>
        
      </AboutDetails>
    </AboutWrapper>
    </>

    </Layout>
  );
};

export default AboutPage;
